import axios from '@/node-modules/axios'

const getQuestions = async (presentationId: number) => {
  const res = await axios.get('/question/list', {
    params: {
      id: presentationId,
      orderBy: 'ASC',
    },
  })

  return res.data
}

const updateQuestion = (questionId: number, payload: any) => axios.put(`/question/update/${questionId}`, payload)

export default {
  getQuestions,
  updateQuestion,
}
